import { useState } from "react";
import useUser from "../hooks/useUser";
import SmallSelectField from "./SmallSelectField";
import { patchData } from "../backend";
import { DATE_FORMAT_MAP, TIME_FORMAT_MAP } from "../utils";

function SettingsFormatting() {
  const { user, refreshUser } = useUser();

  const [dateFormat, setDateFormat] = useState<string>(user?.dateFormat ?? "DD MMMM YYYY");
  const [timeFormat, setTimeFormat] = useState<string>(user?.timeFormat ?? "hh:mmaa");
  const [numberFormat, setNumberFormat] = useState<string>(user?.numberFormat ?? "COMMA");

  const [saveState, setSaveState] = useState<"INITIAL" | "PENDING" | "SAVING" | "SAVED">("INITIAL");

  async function handleSave() {
    setSaveState("SAVING");

    await patchData("/auth/me/", { dateFormat, numberFormat })
      .then(refreshUser);

    setSaveState("SAVED");
  }

  return (
    <div className="flex flex-col p-8 w-full">

      <div className="flex items-end">
        <div className="flex flex-col">
          <div className="font-gilroy font-semibold text-lg">
            Global Formatting Settings
          </div>
          <div className="text-gray-400 text-sm font-semibold">
            Formatting settings will apply globally unless overwritten at the source field level.
          </div>
        </div>
      </div>

      <div className="flex flex-col gap-4 mt-4">

        <div className="flex items-center gap-2">

          <SmallSelectField className="w-72" label="Date Format" value={dateFormat} onChange={(value) => { setDateFormat(value); setSaveState("PENDING"); }}>
            {Object.entries(DATE_FORMAT_MAP).map(([value, label]) => <option key={value} value={value}>{label}</option>)}
          </SmallSelectField>

          {/* NOTE: Time format is not currently displayed as an option */}
          <SmallSelectField className="w-56 hidden" label="Time Format" value={timeFormat} onChange={(timeFormat: string) => { setTimeFormat(timeFormat); setSaveState("PENDING"); }}>
            {Object.entries(TIME_FORMAT_MAP).map(([value, label]) => <option key={value} value={value}>{label}</option>)}
          </SmallSelectField>
        </div>


        <SmallSelectField className="w-72" label="Number Format" value={numberFormat} onChange={(value) => { setNumberFormat(value); setSaveState("PENDING"); }}>
          <option value="COMMA">Comma Separated (e.g. 1,234.00)</option>
          <option value="PERIOD">Period Separated (e.g. 1.234,00)</option>
        </SmallSelectField>

        <button className="btn btn-blue text-sm w-40 px-2 py-1 transition-colors" disabled={saveState !== "PENDING"} onClick={handleSave}>
          {saveState === "SAVING" ? "Saving..." : (saveState === "SAVED" ? "Saved" : "Save")}
        </button>
      </div>

    </div>
  );
}

export default SettingsFormatting;
